<script>
    import axios from 'axios'
    import orderBy from "lodash/orderBy";
    import {nextTick} from "vue";
    import {Listeners} from "../../constants/listeners";
    import Button from "primevue/button";
    import AdaptersDialog from "../adapters/Dialog.vue";
    import InputText from "primevue/inputtext";
    import Checkbox from "primevue/checkbox";
    import AdaptersOverlayPanel from "../adapters/OverlayPanel.vue";
    import Divider from "primevue/divider";
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import {FilterMatchMode} from "primevue/api";
    import IconField from "primevue/iconfield";
    import InputIcon from "primevue/inputicon";

    export default {
        data() {
            return {
                filterName: null,
                filterFavorite: false,
                filterReplace: true,
                showFilterReplace: false,
                filterError: null,
                searchFilterName: null,
                loading: false,
                userFilters: [],
                userFavoriteFilters: {
                    'filterName': {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    }
                },
            }
        },
        props: ['filter', 'filters', 'reportName'],
        mounted() {
            var self = this;
            axios({
                method: 'get',
                url: this.getFilterApiUrl + '/' + this.reportName,
                withCredentials: true
            })
                .then(function (response) {
                    self.userFilters = response.data.result;
                });

        },
        methods: {
            applyFilter(item) {
                this.$refs.overlay.hide();
                this.$emitter.emit(Listeners.KS_FILTER_APPLY_SAVED, JSON.parse(item.filter));
                this.$emitter.emit(this.getListenerClosePopupSave);
            },
            saveFilter(){
                let self = this;
                if(!this.filterName){
                    this.filterError = this.$t('lang.main.filter.name_error');
                    return false;
                }

                let data = {
                    filterName: this.filterName,
                    reportName: this.reportName,
                    favorite: this.filterFavorite,
                    filter: JSON.stringify({
                        filter: this.filter,
                        filters: this.filters
                    })
                };

                if(this.showFilterReplace && this.filterReplace){
                    data['filterReplace'] = this.filterReplace;
                }

                this.loading = true;
                axios({
                    method: 'post',
                    url: this.getFilterApiUrl,
                    withCredentials: true,
                    data: data
                })
                .then(function (response) {

                    self.userFilters.splice(0, self.userFilters.length);
                    response.data.result.forEach(item => {
                        self.userFilters.push(item);
                    });

                    self.closeModalSaveFilter();
                    self.loading = false;

                })
                .catch(function (error) {
                    self.filterError = error.response.data.message;

                    if(error.response.status === 409){
                        self.showFilterReplace = true;
                    }
                    self.loading = false;
                });


            },
            toggleFavorite(item){
                let self = this;
                self.loading = true;
                axios({
                    method: 'patch',
                    url: this.getFilterApiUrl + "/" + item.id,
                    withCredentials: true,
                    data: {favorite: !item.favorite}
                })
                .then(function (response) {
                    item.favorite = !item.favorite;
                    self.loading = false;
                });
            },

            saveFilterName(item){
                let self = this;
                self.loading = true;
                axios({
                    method: 'patch',
                    url: this.getFilterApiUrl + "/" + item.id,
                    withCredentials: true,
                    data: {filterName: self.filterName}
                })
                .then(function (response) {

                    item.filterName = self.filterName;
                    item.edit = false;
                    item.error = null;
                    self.filterName = null;
                    self.loading = false;

                })
                .catch(function (error) {
                    item.error = error.response.data.message;
                    self.loading = false;
                });

            },

            deleteFilter(item){
                let self = this;
                self.loading = true;
                axios({
                    method: 'delete',
                    url: this.getFilterApiUrl + "/" + item.id,
                    withCredentials: true
                })
                .then(function (response) {
                    let index = self.userFilters.findIndex(i => i.id === item.id);
                    self.userFilters.splice(index, 1);
                    self.loading = false;
                });
            },
            closeModalSaveFilter() {
                this.$emitter.emit(this.getListenerClosePopupSave);
                this.filterName = null;
                this.filterFavorite = false;
                this.filterError = null;
                this.filterReplace = true;
                this.showFilterReplace = false;
            },
            edit(item, index) {
                item.edit = true;
                this.filterName = item.filterName;
                let self = this;
                nextTick(() => {
                    self.$refs["filterName-" + item.id].$el.focus()
                })
            },
            onShowPopupSaveFilter() {
                this.filterName = '';
                this.$emitter.emit(this.getListenerOpenPopupSave);
            },
            onShowFavoritesModal(e) {
                if (this.$refs.overlay.isOpen) {
                    this.$refs.overlay.hide();
                    return;
                }
                this.$refs.overlay.show(e);
            },
            onShowPopupFiltersEdit() {
                this.$emitter.emit(this.getListenerOpenPopupEdit);
            }
        },
        computed: {
            getFilterApiUrl() {
                return this.$config.API_URL + '/report/filter';
            },

            filterUserFilters(){
                var self = this;
                return orderBy(this.userFilters.filter(filter => {
                    if(!self.searchFilterName){
                        return filter;
                    }
                    return filter.filterName.toLowerCase().indexOf(self.searchFilterName.toLowerCase()) !== -1;
                }), 'filterName');
            },

            favoritesUserFilters() {
                return orderBy(this.userFilters.filter(filter => {
                    return filter.favorite;
                }), 'filterName');
            },
            getListenerOpenPopupSave() {
                return Listeners.KS_POPUP_SAVE_FILTER_OPEN;
            },
            getListenerClosePopupSave() {
                return Listeners.KS_POPUP_SAVE_FILTER_CLOSE;
            },
            getListenerOpenPopupEdit() {
                return Listeners.KS_POPUP_EDIT_FILTERS_OPEN;
            },
        },
        components: {
            Button,
            AdaptersDialog,
            InputText,
            Checkbox,
            AdaptersOverlayPanel,
            Divider,
            DataTable,
            Column,
            IconField,
            InputIcon,
        }
    }
</script>
<template>
    <span>
        <template v-if="reportName">
            <a class="graybutton" @click.prevent="onShowPopupSaveFilter" :title="$t('lang.main.filter.save')"><i class="fa fa-floppy-o"></i></a>
            <a class="graybutton" @click="onShowFavoritesModal" ref="favorites"><i class="fa fa-filter" aria-hidden="true"></i></a>
            <AdaptersOverlayPanel ref="overlay" :loading="loading">
                <div class="grid">
                    <div class="col">
                        <Button
                            :label="$t('lang.main.filter.control')"
                            class="p-button-extra-sm w-full"
                            @click="onShowPopupFiltersEdit"
                        />
                    </div>
                </div>
                <Divider />
                <div class="grid flex-column">
                    <div class="col">
                        <i class="fa fa-star favorite"></i>&nbsp;{{$t('lang.main.filter.favorites')}}
                    </div>
                    <template v-if="favoritesUserFilters.length === 0">
                        <div class="col"><span>{{$t('lang.main.filter.not_set')}}</span></div>
                    </template>
                    <template v-else>
                        <div v-for="f in favoritesUserFilters" class="col">
                            <Button :label="f.filterName" :title="f.filterName" @click.prevent="applyFilter(f)" class="p-button-extra-sm w-full text-left" text />
                        </div>
                    </template>
                </div>
            </AdaptersOverlayPanel>
        </template>
        <AdaptersDialog
            :listener-id="getListenerOpenPopupSave"
            :listener-close-id="getListenerClosePopupSave"
            :loading="loading"
            :header="$t('lang.main.filter.save')"
            :callback-agree="saveFilter"
            :button-agree-label="$t('lang.main.btn.save')"
            :callback-on-hide="closeModalSaveFilter"
            :error-message="filterError"
        >
            <template #content>
                <div class="field">
                    <label>{{$t('lang.main.filter.name')}}</label>
                    <InputText v-model="filterName" maxlength="64" @keyup.enter="saveFilter" />
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="filterFavorite" :binary="true" inputId="favorites" />
                    <label for="favorites">{{ $t('lang.main.filter.add_favorite') }}</label>
                </div>
                <div v-if="showFilterReplace" class="field-checkbox">
                    <Checkbox v-model="filterReplace" :binary="true" inputId="replace" />
                    <label for="replace">{{ $t('lang.main.filter.replace') }}</label>
                </div>
            </template>
        </AdaptersDialog>
        <AdaptersDialog
            :listener-id="getListenerOpenPopupEdit"
            :listener-close-id="getListenerClosePopupSave"
            :header="$t('lang.main.filter.list')"
            :loading="loading"
        >
            <template #content>
                <DataTable
                    v-model:filters="userFavoriteFilters"
                    :value="filterUserFilters"
                    :rows="filterUserFilters.length"
                    dataKey="id"
                    :loading="loading"
                    :globalFilterFields="['filterName']"
                    :scrollable="true"
                    :stripedRows="true"
                >
                    <template #header>
                        <div class="flex justify-content-end">
                            <IconField iconPosition="left">
                                <InputIcon class="pi pi-search" />
                                <InputText
                                    v-model="userFavoriteFilters.filterName.value"
                                    :placeholder="$t('lang.main.filter.placeholder_search')"
                                />
                            </IconField>
                        </div>
                    </template>
                    <Column field="id" :header="$t('lang.main.filter.table_columns.id')">
                        <template #body="columnProps">
                            <span>{{ columnProps.index + 1 }}</span>
                        </template>
                    </Column>
                    <Column field="filterName" :header="$t('lang.main.filter.table_columns.name')">
                        <template #body="{ data }">
                            <template v-if="!data.edit">
                                <a href="#" @click.prevent="applyFilter(data)" :title="$t('lang.main.filter.apply')">
                                    {{ data.filterName }}
                                </a>
                            </template>
                            <template v-else>
                                <InputText
                                    v-model="filterName"
                                    maxlength="64"
                                    @keyup.enter="saveFilterName(data)"
                                    :ref="'filterName-' + data.id"
                                />
                            </template>
                        </template>
                    </Column>
                    <Column>
                        <template #body="{ data }">
                            <template v-if="data.edit">
                                <span :title="$t('lang.main.btn.save')" @click.prevent="saveFilterName(data)"><i class="fa fa-check ks-icons" aria-hidden="true"></i></span>
                                <span :title="$t('lang.main.btn.close')" @click.prevent="data.edit = false; data.error = null; filterName = null;"><i class="fa fa-times ks-icons icon-danger" aria-hidden="true"></i></span>
                            </template>
                            <template v-else>
                                <span :title="data.favorite ? $t('lang.main.filter.remove_favorite') : $t('lang.main.filter.add_favorite')" @click.prevent="toggleFavorite(data)">
                                    <i class="fa fa-star" :class="{'favorite': data.favorite, 'not-favorite': !data.favorite}"></i>
                                </span>
                                <span :title="$t('lang.main.filter.edit_name')"><i class="fa fa-pencil ks-icons" aria-hidden="true" @click.prevent="edit(data)"></i></span>
                                <span :title="$t('lang.main.btn.delete')" @click.prevent="deleteFilter(data)"><i class="fa fa-trash-o ks-icons icon-danger" aria-hidden="true"></i></span>
                            </template>
                        </template>=
                    </Column>
                </DataTable>
            </template>
        </AdaptersDialog>
    </span>
</template>

<style scoped>

    .tree-container{
        overflow-x: hidden;
        overflow-y: scroll;
        height: 400px;
        font-size: 13px;
        padding-top: 5px;
    }
    ul.tree-container{
        list-style: none;
        margin: inherit;
        padding: 0px;
    }

    ul.tree-container li{
        /*padding: 3px;*/
        padding-left: 3px;
    }

    ul.tree-container li:hover{
        background: #e9f1f7;
    }

    .edit{
        background: #e9f1f7;
    }

    .favorite{color: #fd0;}
    .not-favorite{color: #ddd;}
    .filter-item{
        display: inline-block;
        width: 470px;
        cursor: pointer;
        font-size: 13px;
    }

    .filter-item-edit{
        display: inline-block;
        width: 470px;
    }

    .filter-item-edit input{
        width: 100%;
    }

    .filter-action{
        display: inline-block;
        /*overflow: hidden;*/
    }

    .filter-action span{
        cursor: pointer;
    }

</style>
